import { useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';
import { NavigateFunction } from 'react-router-dom';

import { TLocalesKeys } from 'localization';
import {
  UPDATE_WORKER,
  IUpdateWorkerRequest,
  IUpdateWorkerResponse,
} from 'schemas';
import notification from 'services/notificationService';

import { TUpdateWorker } from './interfaces';

export const useUpdateWorker = (
  t: TTranslator<TLocalesKeys>,
  navigate: NavigateFunction
): TUpdateWorker => {
  const [updateWorker] = useMutation<
    IUpdateWorkerResponse,
    IUpdateWorkerRequest
  >(UPDATE_WORKER, {
    onCompleted: () => {
      navigate('/workers');
      notification.info({
        t,
        title: t('worker.updated'),
        type: 'success',
        dismiss: 5,
      });
    },
    onError: (error) => {
      if (error?.message.includes('self')) {
        notification.info({
          t,
          title: t('worker.updated.error2'),
          type: 'error',
          dismiss: 5,
        });
      } else {
        notification.info({
          t,
          title: t('worker.updated.error'),
          type: 'error',
          dismiss: 5,
        });
      }
    },
  });

  return updateWorker;
};
